import { IDriverWalletHistory } from "models/driverWallet";

export default function AlterBy(value: IDriverWalletHistory) {
  if (value.trip) {
    return (
      <div className="flex flex-col gap-1">
        <p>By Trip</p>
        <div className="text-gray-500 text-xs flex flex-col gap-y-1">
          <div className="flex flex-row gap-x-2 items-center">
            <div className="max-w-3 w-full h-3 rounded-full bg-black flex items-center justify-center">
              <p className="max-w-1.5 w-full h-1.5 rounded-full bg-white"></p>
            </div>
            {value.trip?.pickup_address}
          </div>
          <div className="flex flex-row gap-x-2 items-center">
            <div className="max-w-3 w-full h-3 rounded-full bg-yellow-400 flex items-center justify-center">
              <p className="max-w-1.5 w-full h-1.5 rounded-full bg-black"></p>
            </div>
            {value.trip?.drop_off_address}
          </div>
          <div className="flex flex-row gap-x-2 items-center pl-5 font-bold capitalize">
            {value.trip?.type}
          </div>
        </div>
      </div>
    );
  }
  const isTransfer = value.reason?.includes("Wallet Transfer");
  
  return (
    <div className="flex flex-col gap-1">
      {isTransfer ? (
        <div className="flex flex-col gap-1">
           <span className={`px-2 py-0.5 rounded text-[10px] font-bold w-fit ${
             value.reason.includes("TO:") ? "bg-orange-100 text-orange-700" : "bg-green-100 text-green-700"
           }`}>
             {value.reason.includes("TO:") ? "SENDING TRANSFER" : "RECEIVING TRANSFER"}
           </span>
           <p className="text-black text-sm font-medium">
             {value.reason.split(": ")[1] || value.reason}
           </p>
        </div>
      ) : (
        <p className="font-medium text-black">
          {value.reason}
        </p>
      )}
      {value.admin && (
        <p className="text-gray-500 text-xs">
          Processed by {value.admin.first_name} {value.admin.last_name}
        </p>
      )}
    </div>
  );
}
